<template>
  <div class="app" :class="mainClass">

    <show-image />

    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a v-if="isPhone && signedIn" href="" class="navbar-item" @click.prevent="toggleSidebar">
          <i class="fas fa-bars"></i>
        </a>
        <div v-else class="navbar-item digger-icon">
          <img src="/img/excavator.png" />
        </div>
        <div v-if="signedIn" class="navbar-item has-text-weight-bold page-name">
          {{ $route.name }}
        </div>
      </div>
      <div class="navbar-menu">
        <div class="navbar-end">
          <div class="navbar-item has-text-warning has-text-weight-bold">
            Jackson's Earthmoving
          </div>
        </div>
      </div>
    </nav>

    <div class="sidebar">
      <div class="sidebar-inner">
        <side-menu @link-click="onLinkClick" />
      </div>
    </div>
    <div class="sidebar-mask" v-if="showSidebar && isPhone" @click.prevent="showSidebar = false"></div>
    <div class="app-container">
      <div class="app-container-inner">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import SideMenu from '@/components/SideMenu'
import ShowImage from '@/components/ShowImage'
export default {
  name: 'App',
  components: {
    SideMenu,
    ShowImage
  },
  data () {
    return {
      title: 'Jacksons Earthmoving',
      showSidebar: false,
      serverVersion: null,
      updateNeededIntervalTimer: null,
      screenWidth: 0
    }
  },
  computed: {
    localVersion () { return this.$store.getters.version },
    isPhone () { return this.$store.getters.isPhone },
    signedIn () { return this.$store.getters.user !== null },
    username () { return this.signedIn ? this.$store.getters.user.username : '' },
    firstName () { return this.signedIn ? this.$store.getters.user.firstName : '' },
    lastName () { return this.signedIn ? this.$store.getters.user.lastName : '' },
    printer () { return this.$store.getters.printer },
    mainClass () {
      let classes = {
        printer: this.printer,
        'signed-id': this.signedIn,
        'signed-out': !this.signedIn
      }

      classes['sidebar-visible'] = this.showSidebar && this.signedIn
      classes['sidebar-hidden'] = !this.showSidebar || !this.signedIn
      return classes
    },
    user () {
      return this.$store.getters.user
    }
  },
  watch: {
    user (user) {
      if (!user) return
      console.log('user', user)
      let priv = this.$route.meta.privilege || ''
      if (!priv.length) return
      let userPrivs = user.privileges || []
      let privs = priv.split(', ')
      for (const p of privs) {
        if (userPrivs.includes(p)) {
          return
        }
      }
      alert('Cannot access page')
      this.$router.replace('home')
    }
  },
  created () {
    console.log('App created')
    this.onResize()
    window.addEventListener('resize', this.onResize)
    this.showSidebar = !this.isPhone
    this.initServiceWorker()
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    initServiceWorker () {
      console.log('initServiceWorker')
      this.subs.settings = this.$firestore.collection('settings')
        .doc('system')
        .onSnapshot(snapshot => {
          this.serverVersion = this.$utils.snapshotToObj(snapshot).version
          clearInterval(this.updateNeededIntervalTimer)
          if (this.serverVersion > this.localVersion) {
            console.log(`server has newer version ${this.serverVersion}`)
            document.dispatchEvent(new CustomEvent('swUpdatedNeeded'))
            this.updateNeededIntervalTimer = setInterval(() => {
              document.dispatchEvent(new CustomEvent('swUpdatedNeeded'))
            }, 10000)
          }
        })

      document.addEventListener('swUpdated', e => {
        console.log('refreshNeeded')
        let registration = e.detail
        if (registration && registration.waiting) {
          registration.waiting.postMessage('skipWaiting')
        }
      })
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('controllerchange')
        if (this.serverVersion && this.localVersion === this.serverVersion) return
        this.$dialog.confirm({
          title: `App Update - v${this.serverVersion}`,
          message: 'There is a new version available.',
          confirmText: 'Update',
          onConfirm: () => {
            this.showReloadingModal = true
            window.location.reload()
          }
        })
      })
    },
    onResize () {
      this.screenWidth = document.documentElement.clientWidth
      let isPhone = this.screenWidth < 960 // || document.documentElement.clientWidth < 1000
      this.showSidebar = !isPhone
      this.$store.dispatch('setIsPhone', isPhone)
    },
    onLinkClick () {
      if (this.isPhone) {
        this.showSidebar = false
      }
    },
    toggleSidebar () {
      this.showSidebar = this.showSidebar === null ? false : !this.showSidebar
    }
  }
}
</script>

<style>
html,
body,
.app {
  height: 100%;
  overflow-y: hidden;
}

.app .columns {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.app .modal-content {
  max-height: 100% !important;
}

.app {
  background-color: #fff;
}

.navbar {
  z-index: 40;
}

.navbar .digger-icon {
  padding-right: 80px;
}

.sidebar-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
}

.sidebar {
  height: 100%;
  position: fixed;
  z-index: 11;
  top: 0;
  left: 0;
  padding-top: 52px;
  background-color: #000;
  color: #ccc;
  overflow: hidden;
}

.sign-out:hover {
  background-color: #333;
}

.sidebar-inner {
  height: 100%;
  overflow: auto;
}

.sidebar-hidden .sidebar {
  transition: 200ms;
}

.app-container-inner {
  height: 100%;
  overflow: auto;
  padding: 10px 0 62px 0;
}

.app-container {
  height: 100%;
  transition: 200ms;
}

.sidebar-hidden .app-container {
  transition: 200ms;
  padding-left: 0;
}

.sidebar-visible .sidebar {
  transition: 200ms;
  left: 0;
}

.sidebar { width: 160px; }
.sidebar-hidden .sidebar { left: -160px; }
.app-container { padding-left: 160px; }

@media screen and (min-width: 960px) {
  .page-name {
    padding-left: 70px;
  }
}

@media screen and (max-width: 960px) {
  .app-container {
    padding-left: 0;
  }
}

</style>
